const env = process.env.NODE_ENV;

export default {
	touch: require(`./touch/${env}`),

	www: require(`./www/${env}`),
};



// WEBPACK FOOTER //
// ./src/config/index.js